import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../../utils/Methods";
import { IDS } from "../../../../../utils/IDS";

// role - Get All (Read)
export const GetAllIntermediate = createAsyncThunk(
  "equipment-intermediant/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Intermediate_Equipment}?term=${filter?.name ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&instrument_id=${filter?.instrument_id ||
          ""}&instrument_name=${filter?.instrument_name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Get (Read)
export const GetSingle = createAsyncThunk(
  "equipment-intermediant/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Intermediate_Equipment}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Create (Add)
export const CreateIntermediateEquipment = createAsyncThunk(
  "equipment-intermediant/create",

  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Intermediate_Equipment, data);

      return res; // The new role object
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

export const UpdateIntermediateEquipment = createAsyncThunk(
  "equipment-intermediate/update",
  async ({ id, sendData }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Intermediate_Equipment}/${id}`, sendData);

      if (res?.success) {
        return res;
      } else {
        return rejectWithValue(res);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

// role - Delete
export const Delete = createAsyncThunk(
  "equipment-intermediant/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Intermediate_Equipment}/${id}`);
      return id; // Return the id of the deleted role
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Status
export const StatusRole = createAsyncThunk(
  "equipment-intermediant/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Intermediate_Equipment}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const GetAllInstrument = createAsyncThunk(
  "equipment-instrument/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Instrument_Equipment}?term=${filter?.name ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&instrument_id=${filter?.instrument_id ||
          ""}&instrument_name=${filter?.instrument_name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const CreateIntrumentEquipment = createAsyncThunk(
  "equipment-intrument/create",

  async ({ data }, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Instrument_Equipment, data);
      return res;
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);
export const InstrumentUpdate = createAsyncThunk(
  "equipment-instrument/update",
  async ({ id, sendData }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Instrument_Equipment}/${id}`, sendData);

      if (res?.success) {
        return res;
      } else {
        return rejectWithValue(res);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const InstrumentMaintanceUpdate = createAsyncThunk(
  "equipment-instrument/mantance-update",
  async ({ id, sendData }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Instrument_Equipment}/maintance-status/${id}`,
        sendData,
      );

      if (res?.success) {
        return res;
      } else {
        return rejectWithValue(res);
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const GetSingleInstrument = createAsyncThunk(
  "equipment-instrument/get-single",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Instrument_Equipment}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const instrumentDelete = createAsyncThunk(
  "equipment-instrument/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Instrument_Equipment}/${id}`);
      return id; // Return the id of the deleted role
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "equipment",
  initialState: {
    data: {},
    data_instrument: {},
    single_instrument: {},
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAllIntermediate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllIntermediate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || {};
      })
      .addCase(GetAllIntermediate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CreateIntermediateEquipment.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateIntermediateEquipment.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        // state.data.unshift(action.payload.data);
      })
      .addCase(CreateIntermediateEquipment.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CreateIntrumentEquipment.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateIntrumentEquipment.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        // state.data.unshift(action.payload.data);
      })
      .addCase(CreateIntrumentEquipment.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(UpdateIntermediateEquipment.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateIntermediateEquipment.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(UpdateIntermediateEquipment.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(InstrumentMaintanceUpdate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(InstrumentMaintanceUpdate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        if (updated && state.data?.data) {
          const index = state.data.data.findIndex(
            (item) => item.id === updated.id,
          );

          if (index !== -1) {
            state.data.data[index] = updated; //LIVE UPDATE
          }
        }
      })
      .addCase(InstrumentMaintanceUpdate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(InstrumentUpdate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(InstrumentUpdate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;
      })
      .addCase(InstrumentUpdate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingleInstrument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingleInstrument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.single_instrument = action.payload?.data || {};
      })
      .addCase(GetSingleInstrument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

         .addCase(instrumentDelete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(instrumentDelete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
      })
      .addCase(instrumentDelete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusRole.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusRole.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
      })
      .addCase(StatusRole.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllInstrument.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllInstrument.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data_instrument = action.payload?.data;
      })
      .addCase(GetAllInstrument.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
